var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blank-link-icon",class:{
    'blank-link-icon--left-margin': _vm.hasLeftMargin,
    'blank-link-icon--right-margin': _vm.hasRightMargin,
  }},[_c('i',{staticClass:"fas fa-external-link-alt"})])}
var staticRenderFns = []

export { render, staticRenderFns }